import React, {Component} from "react";
import config from "../../../data/SiteConfig";
import Scroll from 'react-scroll'; // Imports all Mixins
import styles from "./Hero.module.scss";

let Link = Scroll.Link;

class Hero extends Component {
    render() {
        return (
            <section className={`js-fullheight ${styles.fh5cohero}`} data-next="yes" style={{backgroundImage: 'url("images/web-1012469.jpg")'}}>
                <div className={styles.fh5cooverlay} />
                <div className={` ${styles.fullheight} container`}>
                    <div className={`${styles.fh5cointro} ${styles.jsfullheight} d-flex `}>
                        <div className={`${styles.fh5cointrotext} d-flex  align-items-stretch `}>
                            <div className={`${styles.fh5cocenterposition} align-self-center`}>
                                <h2 className={styles.animatebox}>Des applications Web à votre service</h2>
                                <p className={styles.animatebox}>
                                    <a href="/services" className={`btn ${styles.btnoutline} btn-outline`}>
                                         En savoir plus
                                    </a>
                                    <a className={`btn btn-primary ${styles.btnprimary}`} href="/contact" >Nous contacter</a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.fh5colearnmore} ${styles.animatebox}`}>
                        <Link activeClass="active" to="fh5co-projects" spy={true} smooth={true} offset={50} duration={1000} >
                            <span className={styles.text}>Découvrir</span><span className={styles.arrow}><i className="icon-arrow-down"/></span>
                        </Link>
                    </div>
                </div>
            </section>
        )

    }
}

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero/Hero.jsx